$(function() {
    // Show comments section in a modal on mobile devices.
    var $commentBtn = $('.comment-button');

    $commentBtn.click(function(e) {
        e.preventDefault();

        var $modal = $(this.getAttribute('popup-target'));

        $modal.removeClass('hidden');
        $('body').addClass('no-scroll');
    });

    // Close modal button
	$('.modal__close').click(function(e) {
		var $modal = $(this).parent('.modal');
		$modal.addClass('hidden');
        $('body').removeClass('no-scroll');
	});
});